export default __webpack_public_path__ + "static/media/imprint-data-policy-mobile.99e98425.jpg";